import { render, staticRenderFns } from "./QueryEvento.vue?vue&type=template&id=abd8dd2e&scoped=true&"
import script from "./QueryEvento.vue?vue&type=script&lang=js&"
export * from "./QueryEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd8dd2e",
  null
  
)

export default component.exports